import type { FC } from 'react';
import { useState } from 'react';
import { GroupedLinesContent } from '../GroupedLinesContent/GroupedLinesContent';
import { GroupedLinesSportHeader } from '../GroupedLinesSportHeader/GroupedLinesSportHeader';
import type { GroupedLinesBySportContentProps } from './GroupedLinesBySportContentWrapper.types';
import styles from './GroupedLinesBySportContentWrapper.module.scss';
export const GroupedLinesBySportContentWrapper: FC<GroupedLinesBySportContentProps> = ({
  lines,
  isInSearch,
  variant,
  groupedByChampionship,
  className
}) => {
  const [isOpen, setIsOpen] = useState(true);
  const handleToggle = () => {
    setIsOpen(!isOpen);
  };
  return <div className={styles.root} data-sentry-component="GroupedLinesBySportContentWrapper" data-sentry-source-file="GroupedLinesBySportContentWrapper.tsx">
      <GroupedLinesSportHeader line={lines[0]} isInSearch={isInSearch} variant={variant} isOpen={isOpen} handleToggle={handleToggle} data-sentry-element="GroupedLinesSportHeader" data-sentry-source-file="GroupedLinesBySportContentWrapper.tsx" />
      {isOpen && Array.from(groupedByChampionship.entries()).map(([championshipKey, championshipLines]) => <GroupedLinesContent key={championshipKey} championshipLines={championshipLines} className={cn(styles.group, className, {
      [styles.outright]: variant === 'OUTRIGHT'
    })} isInSearch={isInSearch} variant={variant} />)}
    </div>;
};